module.exports = __webpack_public_path__ + "static/img/008城市名片8.dc18e6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/008城市名片8.jpg
// module id = elnl
// module chunks = 0